// Client for the server-side fetch-image-by-URL proxy, routed through aica
// (/document/pdf/image-proxy). Used as a fallback when a direct browser fetch is
// CORS-blocked: both paste-time remote-image persistence and PDF-export image
// inlining hit this for hosts that send no CORS header — an org's S3 bucket
// without an open CORS rule, or a remote *.googleusercontent.com image. The
// proxy fetches the bytes server-side (no CORS) and returns a base64 data: URL.
// Returns null on any failure (non-ok, network/parse error) so callers can
// degrade gracefully.
import axios from 'axios';
import { aicaBaseUrl } from '../../../utils/axios-interceptor';

// `axios-interceptor` sets no default timeout, so without this a proxy that
// accepts the connection and then stalls hangs its caller forever — an export
// that never settles, or a paste that never completes. Every caller already
// treats null as "degrade gracefully", so failing fast is strictly better than
// waiting. Generous, because the proxy fetches the bytes server-side first.
const PROXY_TIMEOUT_MS = 20_000;

export async function fetchImageViaProxy(remoteUrl: string): Promise<string | null> {
    try {
        const response = await axios({
            baseURL: aicaBaseUrl,
            url: '/document/pdf/image-proxy',
            method: 'POST',
            data: { url: remoteUrl },
            timeout: PROXY_TIMEOUT_MS,
        });
        // aica returns the proxy's { dataUrl } under the standard AicaResponse `data` field.
        const dataUrl = response.data?.data?.dataUrl;
        return typeof dataUrl === 'string' ? dataUrl : null;
    } catch {
        return null;
    }
}
